var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7C22 4 20.3333 2 16.4444 2H7.55556C3.66667 2 2 4 2 7V17C2 20 3.66667 22 7.55556 22H11",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.645 17.1737C21.645 17.8311 21.4519 18.4341 21.1195 18.9374C20.6345 19.6628 19.8666 20.1751 18.973 20.3066C18.8203 20.3338 18.6631 20.3474 18.5014 20.3474C18.3398 20.3474 18.1826 20.3338 18.0299 20.3066C17.1362 20.1751 16.3683 19.6628 15.8833 18.9374C15.551 18.4341 15.3579 17.8311 15.3579 17.1737C15.3579 15.4191 16.7635 14 18.5014 14C20.2394 14 21.645 15.4191 21.645 17.1737Z",
    stroke: "#7D899D",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6539 21.4677L21.913 21.6445C21.7468 21.6853 21.6166 21.8123 21.5807 21.9801L21.4235 22.6465C21.3382 23.0092 20.8801 23.1181 20.6421 22.8324L18.5 20.3479L16.3579 22.8369C16.1199 23.1226 15.6618 23.0138 15.5765 22.6511L15.4193 21.9846C15.3789 21.8168 15.2487 21.6854 15.087 21.6491L14.3461 21.4723C14.0048 21.3907 13.8835 20.9599 14.1305 20.7106L15.8819 18.9424C16.3669 19.6678 17.1348 20.1801 18.0285 20.3116C18.1812 20.3388 18.3383 20.3524 18.5 20.3524C18.6617 20.3524 18.8188 20.3388 18.9715 20.3116C19.8652 20.1801 20.6331 19.6678 21.1181 18.9424L22.8695 20.7106C23.1165 20.9554 22.9952 21.3861 22.6539 21.4677Z",
    stroke: "#7D899D",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7613 15.8055L19.0263 16.3405C19.0622 16.413 19.1565 16.4856 19.2419 16.4992L19.7224 16.5808C20.0277 16.6307 20.0996 16.8574 19.8795 17.0795L19.5068 17.4558C19.4439 17.5193 19.408 17.6417 19.4305 17.7324L19.5382 18.1994C19.6236 18.5666 19.4305 18.7117 19.1071 18.5167L18.6581 18.2492C18.5772 18.1994 18.4425 18.1994 18.3617 18.2492L17.9126 18.5167C17.5893 18.7072 17.3962 18.5666 17.4815 18.1994L17.5893 17.7324C17.6072 17.6463 17.5758 17.5193 17.5129 17.4558L17.1402 17.0795C16.9201 16.8574 16.992 16.6352 17.2974 16.5808L17.7779 16.4992C17.8587 16.4856 17.953 16.413 17.9889 16.3405L18.2539 15.8055C18.3841 15.5153 18.6176 15.5153 18.7613 15.8055Z",
    stroke: "#7D899D",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7V12",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H14",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H14",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H12",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H12",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17H10",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInformation);
export default __webpack_public_path__ + "static/media/account_information.0649d330.svg";
export { ForwardRef as ReactComponent };